/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import {
    switchMap,
    filter,
    catchError,
    pluck,
    withLatestFrom,
    map,
} from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { filterFarthestAvailabilityByTourId } from 'ui-ticket/src/shared/utils/tourAvailability';
import { getFarthestAvailabilityUrl } from '../api/endpoints';
import {
    fetchFarthestAvailabilitySuccess,
    fetchTourAvailabilityError,
    FETCH_FARTHEST_AVAILABILITY,
} from '../actions/tourAvailabilityActions';
import { MAX_STALE_TIME } from '../constants';

export const fetchFarthestAvailability = (actions$, state$) =>
    actions$.pipe(
        ofType(FETCH_FARTHEST_AVAILABILITY),
        filter(({ payload }) => !!payload?.facilityId),
        withLatestFrom(state$.pipe(pluck('timedEntry'))),
        filter(
            ([
                ,
                {
                    tourAvailability: {
                        farthestAvailability: { lastFetched = 0 },
                    },
                },
            ]) => lastFetched + MAX_STALE_TIME < new Date().getTime()
        ),
        switchMap(([{ payload }]) =>
            ajax.getJSON(getFarthestAvailabilityUrl(payload.facilityId)).pipe(
                map((farthestAvailability) =>
                    fetchFarthestAvailabilitySuccess({
                        farthestByTour:
                            filterFarthestAvailabilityByTourId(farthestAvailability),
                        lastFetched: new Date().getTime(),
                    })
                ),
                catchError((error) => of(fetchTourAvailabilityError(error)))
            )
        )
    );
